export function getAuthoredContent<T>(scriptId: string): T {
	const authoringScript = document.getElementById(scriptId);
	if (authoringScript) {
		const authorSettings = JSON.parse(authoringScript.innerHTML);
		for (const variation in authorSettings) {
			return authorSettings[variation];
		}
	}
	return {} as T;
}
